import PolicyPage from "./PolicyPage";
import { BRAND } from "@/branding.config";

export default function SLA() {
  return (
    <PolicyPage title="Service Level Agreement" description={`${BRAND.app_name} uptime and performance guarantees.`}>
      <p>{BRAND.legal_company_name} commits to the following service levels for all production
      plans on {BRAND.app_name}.</p>

      <h2>Uptime</h2>
      <p>We guarantee <strong className="text-foreground">99.99%</strong> monthly availability
      per VPS instance on Pro and higher tiers, and <strong className="text-foreground">99.999%</strong> on
      Enterprise. Availability is measured excluding scheduled maintenance windows communicated
      at least 72 hours in advance.</p>

      <h2>Service credits</h2>
      <ul>
        <li>Below 99.99% → 10% credit of that month's fee</li>
        <li>Below 99.9% → 25% credit</li>
        <li>Below 99.5% → 50% credit</li>
        <li>Below 99.0% → 100% credit</li>
      </ul>
      <p>Credits are applied automatically to the next invoice — no need to file a claim.</p>

      <h2>Response times</h2>
      <ul>
        <li>Sev 1 (customer down): first response &lt; 15 min, 24/7</li>
        <li>Sev 2 (degraded): first response &lt; 1 hour, business hours</li>
        <li>Sev 3 (general): first response &lt; 4 hours, business hours</li>
      </ul>

      <h2>Network</h2>
      <p>Our tier-3 backbone commits to less than 200µs of jitter and less than 0.001% packet
      loss between any two PurpleVPS regions. Latency to major broker fabrics (LD4, NY4, TY3, TP2)
      is guaranteed within the documented envelope on Pro and higher tiers.</p>

      <h2>Exclusions</h2>
      <ul>
        <li>Force majeure and internet-wide events beyond our control</li>
        <li>Customer misconfiguration or violation of the Acceptable Use Policy</li>
        <li>Beta / preview features explicitly marked as non-SLA</li>
      </ul>

      <p>Full SLA terms and definitions are provided as an addendum to the Master Service
      Agreement for enterprise customers. Contact <a className="text-primary hover:underline" href={`mailto:${BRAND.sales_email}`}>{BRAND.sales_email}</a>.</p>
    </PolicyPage>
  );
}
